const actions = {
	GET_READ_ALOUD: 'GET_READ_ALOUD',
	GET_READ_ALOUD_SUCCESS: 'GET_READ_ALOUD_SUCCESS',

	CREATE_NEW_QUESTION_READ_ALOUD: 'CREATE_NEW_QUESTION_READ_ALOUD',
	CREATE_NEW_QUESTION_READ_ALOUD_SUCCESS: 'CREATE_NEW_QUESTION_READ_ALOUD_SUCCESS',

	DELETE_READ_ALOUD: 'DELETE_READ_ALOUD',
	DELETE_READ_ALOUD_SUCCESS: 'DELETE_READ_ALOUD_SUCCESS',

	GET_READ_ALOUD_DETAIL: 'GET_READ_ALOUD_DETAIL',
	GET_READ_ALOUD_DETAIL_SUCCESS: 'GET_READ_ALOUD_DETAIL_SUCCESS',

	UPDATE_READ_ALOUD_DETAIL: 'UPDATE_READ_ALOUD_DETAIL',
	UPDATE_READ_ALOUD_DETAIL_SUCCESS: 'UPDATE_READ_ALOUD_DETAIL_SUCCESS',

	SPEAKING_LOADING_FALSE: 'SPEAKING_LOADING_FALSE',
	//#region CRUD

	getReadAloud: (model) => ({
		type: actions.GET_READ_ALOUD,
		payload: { model },
	}),

	createQuesReadAloud: (body, cbSuccess, cbError) => ({
		type: actions.CREATE_NEW_QUESTION_READ_ALOUD,
		payload: { body },
		cbSuccess,
		cbError,
	}),

	getReadAloudDetail: (id) => ({
		type: actions.GET_READ_ALOUD_DETAIL,
		payload: { id },
	}),

	updateReadAloudDetail: (model, cbSuccess, cbError) => ({
		type: actions.UPDATE_READ_ALOUD_DETAIL,
		payload: { model },
		cbSuccess,
		cbError,
	}),

	deleteReadAloud: (id, cbSuccess, cbError) => ({
		type: actions.DELETE_READ_ALOUD,
		payload: { id },
		cbSuccess,
		cbError,
	}),
};

export default actions;
